module.exports = __webpack_public_path__ + "img/icon6.7b2b4115.png";